import React, { useEffect, useState } from 'react';
import Router from 'next/router';
import Cookies, { Cookie } from '@model/common/cookie/cookie';
import { Page } from '@model/common';
import { AgentPage } from '@model/common/pages/agent-pages';
import { MyBookingToken } from '@model/mmb';
import { useDispatch, useSelector } from 'react-redux';
import { getBookingToken, resetBookingDetails } from '@state/mmb';
import { performRedirect } from '@state/app';
import { clearAgent } from '@state/agent/agentOperations';

export const withAgentLogin = (WrappedComponent: any) => (props: any) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const loggedIn: boolean = !!new Cookies().get(Cookie.TRADE_AUTHORIZATION);
  if (isClient) {
    if (!loggedIn) {
      const dispatch = useDispatch();
      dispatch(clearAgent());
      Router.replace(Page.AGENTS.concat(AgentPage.LOGIN));
    } else {
      return <WrappedComponent {...props} />;
    }
  }
  return null;
};

export const withMMBLogin = (WrappedComponent: any, isLoginPage?: boolean) => (props: any) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const bookingToken: MyBookingToken = useSelector(getBookingToken);
  const dispatch = useDispatch();
  if (isClient) {
    const isAgent: boolean = !!new Cookies().get(Cookie.TRADE_AUTHORIZATION);
    if (!bookingToken?.loginToken && !isAgent) {
      if (!isLoginPage) {
        dispatch(resetBookingDetails());
        dispatch(performRedirect(Page.MY_BOOKING));
      } else {
        return <WrappedComponent {...props} />;
      }
    }

    if (isLoginPage) {
      dispatch(performRedirect(Page.MY_BOOKING_OVERVIEW));
    } else {
      return <WrappedComponent {...props} />;
    }
  }

  return null;
};
